<script setup>
import Tag from 'primevue/tag';

const props = defineProps({
    feedback: {
        type: Number,
        required: true
    },
    class: {
        type: String,
        required: false
    }
})

console.log(props.feedback)
</script>
<template>
    <div v-if="feedback !== null" :class="class">
        <Tag :severity="feedback === 1 ? 'success' : 'danger'" :value="feedback == 1 ? 'O feedback ajudou' : 'O feedback não ajudou'"></Tag>
    </div>
</template>